export enum CallOrigin {
  CC = 0,
  Campaign = 1,
  TeleSales = 2,
  AutoDialer = 3,
}
